import { AfterViewInit, Directive, ElementRef, OnDestroy } from '@angular/core';
import { Subject } from 'rxjs';
import { takeUntil, tap } from 'rxjs/operators';
import { CurrentCompanyService } from '../../../core';
import { Currency } from '../models/currency.model';

@Directive({
  selector: '[mdCurrency]',
})
export class CurrencyDirective implements AfterViewInit, OnDestroy {
  destroy$: Subject<any> = new Subject();

  constructor(
    private elementRef: ElementRef,
    private currentCompanyService: CurrentCompanyService,
  ) {}

  ngAfterViewInit() {
    this.currentCompanyService.currency$
      .pipe(
        tap((currency: Currency) => {
          this.elementRef.nativeElement.innerText = currency.sign;
        }),
        takeUntil(this.destroy$),
      )
      .subscribe();
  }

  ngOnDestroy() {
    this.destroy$.next(true);
    this.destroy$.complete();
  }
}
